import { isPalette, type PaletteId } from "@greg-chick/shared";

// 히어로 팔레트 색상 단일 정의 — HeroAvatar(SVG)·Phaser 아바타가 공유.
export interface PaletteColors {
  skin: string;
  suit: string;
  accent: string;
}

export const HERO_PALETTES: Record<PaletteId, PaletteColors> = {
  warm: { skin: "#f3c9a3", suit: "#e8743b", accent: "#ffd23f" },
  cool: { skin: "#ecc6a8", suit: "#3b82c4", accent: "#7ed0e8" },
  mint: { skin: "#f1cda9", suit: "#3fae7a", accent: "#bff0d4" },
  berry: { skin: "#eec4ad", suit: "#a23b76", accent: "#f59ac4" },
  sand: { skin: "#f0d2b0", suit: "#c2a25a", accent: "#efe0b0" },
};

export function paletteColors(palette: string | undefined): PaletteColors {
  return HERO_PALETTES[isPalette(palette) ? palette : "warm"];
}

/** "#rrggbb" → 0xRRGGBB (Phaser 색상). */
export function toHexNumber(color: string): number {
  return parseInt(color.replace("#", ""), 16) || 0;
}
